import { CopyIcon, EditIcon } from "assets";
import { CustomTooltip, SmallScreenModel } from "components";
import React, { useState } from "react";
import { copyToClipboard } from "utils/helpers/CopyToClipboard";
import { MembershipPlansProps } from "../store/actionType";
import HandleUpdateMembershipPlan from "./manage_membership_plan/HandleUpdateMembershipPlan";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

const ActionButton: React.FC<{ items: MembershipPlansProps }> = ({
  items,
}) => {
  const [isEditModel, setEditModel] = useState(false);
  const [copied, setCopied] = useState(false);
  const handleCopy = async (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation();
    const success = await copyToClipboard(items.user_id ?? "");
    if (success) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }
  };
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
        authUser &&
        (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
          action?.includes(Authorities.UPDATE_COMMERCIAL_MEMBERSHIP));
  if (isPermitted)
  return (
    <>
      <div className="flex flex-row gap-2 justify-center">
        <CustomTooltip title="Update Membership Plan" placement="bottom">
          <button
            className="hover:text-primary-500"
            onClick={() => setEditModel(true)}
          >
            <EditIcon />
          </button>
        </CustomTooltip>
        <CustomTooltip
          title={copied ? "Id copied!" : "Copy User Id"}
          placement="right"
        >
          <button
            onClick={handleCopy}
            className="p-1 hover:text-blue-600"
          >
            <CopyIcon className="size-5" />
          </button>
        </CustomTooltip>
      </div>
      <SmallScreenModel setShowModal={setEditModel} showModal={isEditModel}>
        <HandleUpdateMembershipPlan
          membershipdata={items}
          closeModal={setEditModel}
        />
      </SmallScreenModel>
    </>
  );
    return <></>;
};

export default ActionButton;
